/*
  ZR PDP - seasonal product page behaviour (change pdp-seasonal-2026).

  1. Price badge "Save N%": follows the SELECTED variant. Boost dispatches
     `on:variant:change` (bubbles, detail.variant with price / compare_at_price
     in cents) and swaps the price block itself, so everything here listens on
     document and re-finds its nodes every time. Rule (Thanh 2026-09-24): show
     strike price + badge whenever compare_at > price; the editor threshold
     [data-zr-compare-max] (percent, 100 = never hide) is kept as a safety valve.
  2. Sticky add-to-cart bar (mobile + desktop): shown while the main add-to-cart
     button is out of view (above OR below the viewport); its button clicks the MAIN form's
     own submit button, so the variant and the ShineOn fields go through the
     one form the theme already handles.
  3. Seasonal CTA colour: the shown item of the pdp-note season group carries
     its colours; they become CSS variables for the add-to-cart buttons.
  4. Added-to-cart notice (the theme's "drawer"): free-shipping progress + 4
     recommendations, after `on:cart:add`.
  Contract with the gates: 04_Operations/QA Scripts/pd_common.py.
*/
(function () {
  if (window.ZrPdp) { return; }
  var marker = document.querySelector('.zr-pdp-marker');
  if (!marker) { return; }
  var MAX = parseFloat(marker.getAttribute('data-zr-compare-max') || '100');
  var PREFIX = marker.getAttribute('data-zr-badge-prefix') || '';
  var FREE = parseFloat(marker.getAttribute('data-zr-free-ship') || '0') * 100;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function area() { return document.querySelector('.product-detail__title-area'); }

  function placeBadge() {
    var a = area(), b = document.querySelector('.zr-pdp-badge');
    if (!a || !b) { return null; }
    if (b.parentNode !== a) { a.appendChild(b); }
    return b;
  }

  function applyVariant(v) {
    if (!v) { return; }
    var b = placeBadge(), a = area();
    var p = v.price, c = v.compare_at_price || 0;
    var pct = c > p ? Math.round((c - p) / c * 100) : 0;
    var show = c > p && pct <= MAX;
    if (b) {
      if (show) { b.textContent = PREFIX + ' ' + pct + '%'; b.removeAttribute('hidden'); }
      else { b.setAttribute('hidden', ''); }
    }
    if (a) { a.classList.toggle('zr-pdp-nocompare', !show); }
    var sp = document.querySelector('.zr-sticky-atc__price');
    var sv = document.querySelector('.zr-sticky-atc__variant');
    if (sp) { sp.textContent = money(p); }
    // A single-variant product is called "Default Title" by Shopify: say nothing.
    if (sv) { sv.textContent = (v.title && v.title !== 'Default Title') ? v.title : ''; }
  }

  document.addEventListener('on:variant:change', function (ev) {
    var v = ev.detail && ev.detail.variant;
    // Boost swaps the price node after the event; place the badge once it settles.
    applyVariant(v);
    setTimeout(function () { applyVariant(v); }, 400);
  });

  /* ---- sticky bar ---- */
  var bar = document.querySelector('.zr-sticky-atc');
  // The bar is rendered inside main-product, and MAIN is position:relative;
  // z-index:1 - its own stacking context. The footer section (also z-index:1,
  // later in the DOM) then paints OVER the bar while it scrolls past: the bar
  // vanished behind the footer (PD-G11, 2026-09-24). Lift it to <body> so its
  // z-index counts against the whole page.
  if (bar && bar.parentNode !== document.body) { document.body.appendChild(bar); }
  function mainForm() { return document.querySelector('.product-detail product-form') || document.querySelector('product-form'); }
  function mainSubmit() {
    var f = mainForm();
    return f ? f.querySelector('form[action*="/cart/add"] button[type=submit]') : null;
  }
  // Visibility comes from the form's position, recomputed on scroll (rAF-
  // throttled). IntersectionObserver alone is not enough: a jump from the bottom
  // of the page straight to the top moves the form from "above the viewport" to
  // "below the viewport" without ever intersecting, so no callback fires and the
  // bar stayed up (PD-G11, 2026-09-24).
  // Thanh 2026-09-24: the bar shows whenever the main add-to-cart button is
  // off screen - below it too (a product with many options pushes the button
  // under the first screen), not only after scrolling past it.
  function syncBar() {
    var b = mainSubmit() || mainForm();
    if (!b) { return; }
    var r = b.getBoundingClientRect();
    var off = r.bottom < 0 || r.top > window.innerHeight;
    bar.classList.toggle('is-visible', off);
    bar.setAttribute('aria-hidden', off ? 'false' : 'true');
  }
  if (bar && mainForm()) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) { return; }
      ticking = true;
      requestAnimationFrame(function () { ticking = false; syncBar(); });
    }, { passive: true });
    window.addEventListener('resize', syncBar);
    syncBar();
    var btn = bar.querySelector('.zr-sticky-atc__btn');
    if (btn) {
      btn.addEventListener('click', function () {
        var s = mainSubmit();
        if (s) { s.click(); }
      });
    }
  }

  /* ---- seasonal CTA colour ---- */
  function seasonColours() {
    var shown = document.querySelector('[data-zr-season-group="pdp-note"] [data-zr-season]:not([hidden])');
    if (!shown) { return; }
    var r = document.documentElement.style;
    r.setProperty('--zr-pdp-cta-bg', shown.getAttribute('data-cta-bg'));
    r.setProperty('--zr-pdp-cta-text', shown.getAttribute('data-cta-text'));
  }
  document.addEventListener('zr-season:applied', seasonColours);

  /* ---- added-to-cart notice: free shipping progress + 4 recommendations ---- */
  var LABEL_BELOW = marker.getAttribute('data-zr-ship-below') || '';
  var LABEL_REACHED = marker.getAttribute('data-zr-ship-reached') || '';
  var RECS_HEADING = marker.getAttribute('data-zr-recs-heading') || '';
  function notice() { return document.querySelector('.added-notice'); }
  function renderShip(cart, host) {
    var old = host.querySelector('.zr-ship-progress');
    if (old) { old.remove(); }
    if (!FREE) { return; }
    var total = cart.total_price, left = Math.max(0, FREE - total);
    var d = document.createElement('div');
    d.className = 'zr-ship-progress';
    var t = document.createElement('p');
    t.className = 'zr-ship-progress__text';
    t.textContent = left > 0 ? LABEL_BELOW.replace('{amount}', money(left)) : LABEL_REACHED;
    var bar2 = document.createElement('div');
    bar2.className = 'zr-ship-progress__bar';
    var fill = document.createElement('span');
    fill.style.width = Math.min(100, Math.round(total / FREE * 100)) + '%';
    bar2.appendChild(fill);
    d.appendChild(t); d.appendChild(bar2);
    host.insertBefore(d, host.firstChild);
  }
  function renderRecs(productId, host) {
    var old = host.querySelector('.zr-notice-recs');
    if (old) { old.remove(); }
    if (!productId) { return; }
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        var ps = (j.products || []).slice(0, 4);
        if (!ps.length) { return; }
        var w = document.createElement('div');
        w.className = 'zr-notice-recs';
        var h = document.createElement('p');
        h.className = 'zr-notice-recs__h';
        h.textContent = RECS_HEADING;
        w.appendChild(h);
        var g = document.createElement('div');
        g.className = 'zr-notice-recs__grid';
        ps.forEach(function (p) {
          var a = document.createElement('a');
          a.href = p.url;
          a.className = 'zr-notice-recs__item';
          if (p.featured_image) {
            var im = document.createElement('img');
            im.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200';
            im.alt = ''; im.loading = 'lazy'; im.width = 100; im.height = 100;
            a.appendChild(im);
          }
          var s = document.createElement('span');
          s.textContent = p.title;
          a.appendChild(s);
          g.appendChild(a);
        });
        w.appendChild(g);
        host.appendChild(w);
      })['catch'](function () {});
  }
  // This Boost build is the jQuery one: it has NO on:cart:add event (measured in
  // theme.js 2026-09-24). It builds .added-notice after its own /cart.js call. So:
  // hear the add-to-cart form submit (capture phase), then wait - bounded, 6 s -
  // for a NEW notice, and fill it. No MutationObserver (it once hung a tab here).
  function refreshNotice(productId, before) {
    var tries = 0;
    (function wait() {
      var host = notice();
      var fresh = host && host !== before && !host.querySelector('.zr-ship-progress');
      if (!fresh && tries++ < 60) { return setTimeout(wait, 100); }
      if (!fresh) { return; }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        renderShip(cart, host);
        renderRecs(productId || (cart.items[0] && cart.items[0].product_id), host);
      })['catch'](function () {});
    })();
  }
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') < 0) { return; }
    refreshNotice(marker.getAttribute('data-product-id'), notice());
  }, true);

  window.ZrPdp = { applyVariant: applyVariant, refreshNotice: refreshNotice };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { placeBadge(); seasonColours(); });
  } else { placeBadge(); seasonColours(); }
})();
